module.exports = __webpack_public_path__ + "img/logoGreen.8b04758a.svg";